import React from "react";
import dreamcoinLogo from "/dreamcoin-logo.svg";
import ticketLogo from "/spin.svg";
import usdtLogo from "/usdt.svg";
import { getTicketWord } from "../../Services/utils";
import styles from "./Reward.module.css";
import CharacterLogo from "../../../../public/character-circle-gold.svg";

interface RewardProps {
	type: "dc" | "ticket" | "character" | "USDT";
	characterType?: "legendary" | "epic";
	amount: number | string;
	showType?: boolean;
}

export const Reward: React.FC<RewardProps> = ({
	type,
	characterType,
	amount,
	showType,
}) => {
	if (typeof amount === "number") {
		if (amount <= 0) return null;
	}
	if (type === "dc") {
		return (
			<div className={styles.dcReward}>
				{showType || showType === undefined ? (
					<>
						{amount} DC <img src={dreamcoinLogo} alt='dc' />
					</>
				) : (
					<>
						{amount} <img src={dreamcoinLogo} alt='dc' />
					</>
				)}
			</div>
		);
	}

	if (type === "character") {
		return (
			<div className={styles.characterReward}>
				{showType || showType === undefined ? (
					<>
						{characterType === "legendary"
							? "Легендарный"
							: characterType === "epic"
							? "Эпический"
							: "Легендарный"}
						<img src={CharacterLogo} alt='char' />
					</>
				) : (
					<>
						<img src={CharacterLogo} alt='char' />
					</>
				)}
			</div>
		);
	}

	if (type === "USDT") {
		return (
			<div className={styles.usdtReward}>
				{amount} USDT <img src={usdtLogo} alt='USDT' />
			</div>
		);
	}

	const ticketWord = getTicketWord(amount.toString());
	return (
		<div className={styles.ticketReward}>
			{amount} {ticketWord}
			<img src={ticketLogo} alt='Tickets' />
		</div>
	);
};
